import { supabase } from './supabase';

/**
 * Check if invite code system is enabled
 * When disabled, all onboardings handled web-side
 */
export async function isInviteCodeSystemEnabled(): Promise<boolean> {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data, error } = await (supabase.rpc as any)('is_invite_code_system_enabled', {});
    if (error) {
      return false; // Default to disabled on error
    }
    // Ensure boolean return type
    return Boolean(data ?? false);
  } catch {
    return false; // Default to disabled on error
  }
}

/**
 * Check if mobile-first onboarding is enabled
 * When disabled, all onboardings handled web-side
 */
export async function isMobileFirstOnboardingEnabled(): Promise<boolean> {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data, error } = await (supabase.rpc as any)('is_mobile_first_onboarding_enabled', {});
    if (error) {
      return false; // Default to disabled on error
    }
    // Ensure boolean return type
    return Boolean(data ?? false);
  } catch {
    return false; // Default to disabled on error
  }
}

/**
 * Check if we should redirect to mobile app
 * Returns true only if BOTH toggles are enabled
 */
export async function shouldRedirectToMobile(): Promise<boolean> {
  const [inviteCodeEnabled, mobileFirstEnabled] = await Promise.all([
    isInviteCodeSystemEnabled(),
    isMobileFirstOnboardingEnabled(),
  ]);
  
  // Only redirect to mobile if both features are enabled
  return inviteCodeEnabled && mobileFirstEnabled;
}

